module.exports = __webpack_public_path__ + "0c15beb5c789fa26869a9f853eaa79c5.png";